import React from 'react';
export const ModulesSection = () => {
  const modules = [{
    num: '1',
    icon: '🌟',
    title: 'Young Learners Activity Book',
    ageRange: 'Ages 6-11 · Cambridge Starters / Movers',
    desc: '60 páginas bilingües para los más chicos. Vocabulario ilustrado, actividades por unidad, sistema espejo completo, consignas en inglés y explicación en español en cada página opuesta. El padre puede acompañar sin saber inglés.',
    includes: ['8 unidades temáticas ilustradas', 'Vocabulario con pronunciación', 'Actividades con espacio para responder', 'Guía para padres en cada página par', 'Mock Test con grilla de corrección', 'Progress Tracker para colorear']
  }, {
    num: '2',
    icon: '🚀',
    title: 'Teens Bridge Activity Book',
    ageRange: 'Ages 12-17 · Cambridge KET A2 + PET B1',
    desc: '60 páginas bilingües para adolescentes. Temas de conversación reales, gramática aplicada, writing prep, speaking practice y mock test completo. Todo con su espejo en español para que la familia pueda acompañar.',
    includes: ['8 unidades temáticas con texto real', 'Grammar sections A2 y B1', 'Writing preparation (email + story)', 'Speaking role play cards', 'Mock Test 30 puntos + rúbrica', 'Vocabulary bank ilustrado']
  }, {
    num: '3',
    icon: '📖',
    title: 'Grammar Sin Vueltas',
    ageRange: 'Bilingüe · A1 a B1 · 10 temas',
    desc: '60 páginas de gramática explicada EN inglés para el alumno y EN español para la familia. Cada tema tiene su propio color. 10 temas cubiertos de Verb To Be a Passive Voice. Con pronunciación, ejemplos, ejercicios y respuestas.',
    includes: ['10 temas gramaticales con color único', 'Tabla espejo EN + ES + pronunciación', 'Ejercicios con espacio de respuesta', 'Respuestas correctas para padres', 'Consejo de práctica en casa', 'Grammar Progress Tracker']
  }];
  const inclusions = ['60 páginas de contenido sin relleno', 'Ilustraciones en cada actividad', 'Sistema espejo inglés / español', 'Pronunciación en TODAS las tablas', 'Respuestas para el padre/madre', 'Consejo de práctica en casa', 'Mock Test con corrección incluida', 'Progress Tracker visual'];
  return <section className="bg-familia-card py-10 md:py-16 px-4 md:px-6" data-id="element-139">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-140">
        <div className="text-center mb-10 md:mb-16" data-id="element-141">
          <h2 className="text-[22px] sm:text-3xl md:text-5xl font-display font-bold mb-4 md:mb-6" data-id="element-142">
            📚 LOS 3 MÓDULOS — Para preparar <br className="hidden sm:block" data-id="element-143" />
            Cambridge en cualquier nivel
          </h2>
          <p className="text-familia-gray text-[15px] md:text-lg max-w-3xl mx-auto leading-relaxed" data-id="element-144">
            Cada módulo es un sistema completo con actividades en inglés, guía
            en español, vocabulario con pronunciación, respuestas correctas y
            consejos para padres en cada página.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6 mb-10 md:mb-16" data-id="element-145">
          {modules.map((m, i) => <div key={i} className="bg-familia-section border border-familia-cyan/25 p-6 md:p-8 rounded-2xl card-hover flex flex-col" data-id="element-146">
              <div className="flex items-center justify-between mb-4" data-id="element-147">
                <span className="text-familia-cyan font-mono font-bold text-xs sm:text-sm" data-id="element-148">
                  MÓDULO {m.num}
                </span>
                <span className="text-3xl md:text-4xl" data-id="element-149">{m.icon}</span>
              </div>
              <h3 className="text-lg md:text-xl font-display font-bold mb-1" data-id="element-150">
                {m.title}
              </h3>
              <p className="text-familia-gold text-xs sm:text-sm font-semibold mb-4" data-id="element-151">
                {m.ageRange}
              </p>
              <p className="text-familia-gray text-[14px] md:text-sm leading-relaxed mb-6" data-id="element-152">
                {m.desc}
              </p>

              <div className="border-t border-white/10 pt-4 mt-auto" data-id="element-153">
                <p className="text-xs font-bold text-white/90 uppercase tracking-wider mb-3" data-id="element-154">
                  Incluye:
                </p>
                <ul className="space-y-2" data-id="element-155">
                  {m.includes.map((item, j) => <li key={j} className="flex items-start gap-2 text-[13px] text-familia-gray" data-id="element-156">
                      <span className="text-familia-cyan shrink-0" data-id="element-157">→</span>
                      <span data-id="element-158">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>

        <div className="bg-familia-bg border border-familia-cyan/30 border-dashed p-6 md:p-12 rounded-3xl max-w-4xl mx-auto" data-id="element-159">
          <h4 className="text-lg md:text-xl font-display font-bold mb-6 md:mb-8 text-center" data-id="element-160">
            Cada módulo incluye:
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 md:gap-x-12 gap-y-3 md:gap-y-4" data-id="element-161">
            {inclusions.map((item, i) => <div key={i} className="flex items-center gap-3 md:gap-4" data-id="element-162">
                <span className="text-familia-green text-lg md:text-xl" data-id="element-163">
                  ✅
                </span>
                <span className="text-[14px] sm:text-base font-medium" data-id="element-164">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};